import { z } from 'zod';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowInsuranceCardBlockConfigSchema = z.object({
    gsPath: z.string().min(1, 'Cloud storage path is required'),
});
export const FlowInsuranceCardBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.InsuranceCard),
    config: FlowInsuranceCardBlockConfigSchema,
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.InsuranceCard),
});
//# sourceMappingURL=config.js.map